import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import Layout from './views'

const LawZipHeader = () => {
  const { template } = useTemplateContext()
  return (
    <Layout.Header textColor='primary' backgroundColor='secondary'>
      <CommonComponents.Wrapper height="80px">
        <Layout.HeaderContainer>
          <Layout.Logo>
            {template.logo.src ? (
              <Layout.LogoImage src={template.logo.src} />
            ) : (
              <Layout.LogoText fontFamily={template.logo.fontFamily}>
                {template.logo.text}
              </Layout.LogoText>
            )}
          </Layout.Logo>
          {template.sections?.navigation?.hasShoppingCart && (
            <Layout.Navigation
              textColor='secondary'
              hasShoppingCart={template.sections.navigation.hasShoppingCart}
            />
          )}
        </Layout.HeaderContainer>
      </CommonComponents.Wrapper>
    </Layout.Header>
  )
}

export default LawZipHeader
